import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
// eslint-disable-next-line no-unused-vars
import slickcss from 'slick-carousel/slick/slick.css';
import ImageV2 from 'components_v2/common/ImageV2';
import LeadLiveIcon from '../../common/LeadLiveIcon/LeadLiveIcon';
import s from './NewStoryCard.scss';
import { IMAGE_URL } from '../../../constants';
import { CARD_2, CARD_27, CARD_27_1, CARD_29, CARD_9 } from './cards';

function StoryImage({
  msid,
  width,
  height,
  imagesize,
  resizemode,
  cardType,
  hoveredSlikeId,
  gaIndex,
  slikeId,
  imageUrl,
  shouldNotlazyloadImage,
  imagePlaceHolderSrc,
  iconClass,
  videoTime,
  showPlayIconAlso,
  cmstype,
  criticRating,
  showIIcon,
  des,
  showDes,
  onVideoIconClick,
  onShowDesInCard,
  imagelist,
  occupation,
  videoviews,
  isTrendingorNew,
}) {
  const onError = e => {
    e.target.onerror = null;
    e.target.src = imagePlaceHolderSrc || `${IMAGE_URL}34824568.cms`;
  };

  const iconClass2 = cardType === CARD_9 ? s.vsIcon : '';

  const sliderSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: false,
    pauseOnFocus: false,
    dots: false,
    arrows: false,
    swipeToSlide: true,
    autoplay: true,
    draggable: false,
    infinite: true,
  };

  return (
    <div className={`${s.imgWrap} global_img_wrap`}>
      {imagelist && Array.isArray(imagelist) && imagelist.length > 1 ? (
        <Slider {...sliderSettings} className={s.storyImg}>
          {imagelist.map(item => (
            <ImageV2
              key={item.imageid || msid}
              width={width || 600}
              height={height}
              msid={item.imageid}
              imgsize={item.imagesize}
              placeHolderSrc={imagePlaceHolderSrc || `${IMAGE_URL}87458172.cms`}
              onError={imagePlaceHolderSrc ? onError : undefined}
              alt=""
              lazyload={!shouldNotlazyloadImage}
              offsetVertical={300}
              resizemode={item.resizemode}
              hoveredSlikeId={hoveredSlikeId}
              gaIndex={gaIndex}
              hoveredSlikeIndex={gaIndex}
              slikeId={slikeId}
              src={item.imageSrc}
            />
          ))}
        </Slider>
      ) : (
        <div className={`${s.storyImg} global_story_img`}>
          <ImageV2
            key={msid}
            width={width || 600}
            height={height}
            msid={msid}
            imgsize={imagesize}
            placeHolderSrc={imagePlaceHolderSrc || `${IMAGE_URL}87458172.cms`}
            onError={imagePlaceHolderSrc ? onError : undefined}
            alt=""
            lazyload={!shouldNotlazyloadImage}
            offsetVertical={300}
            resizemode={resizemode}
            hoveredSlikeId={hoveredSlikeId}
            gaIndex={gaIndex}
            hoveredSlikeIndex={gaIndex}
            slikeId={slikeId}
            src={imageUrl}
          />
        </div>
      )}

      {/* Shadow Tile */}
      {occupation && <span className={s.shadowTile}>{occupation}</span>}

      {/* Video/Photo Icon */}
      {iconClass && (
        <span
          className={`${s[iconClass]} ${iconClass2}`}
          onClick={e => {
            if (typeof onVideoIconClick === 'function') {
              e.preventDefault();
              e.stopPropagation();
              onVideoIconClick();
            }
          }}
        >
          <i />
          {videoTime && <span> {videoTime} </span>}
        </span>
      )}

      {videoviews && (
        <span className={s.viewIcon}>
          <i />
          {videoviews}
        </span>
      )}

      {isTrendingorNew === 'New' && <span className={s.newPill}>New</span>}

      {isTrendingorNew === 'Trending' && (
        <span className={s.trendingIcon}>
          <i />
        </span>
      )}

      {/* Additional Play Icon */}
      {showPlayIconAlso && (
        <span className={`${s.videoIcon}`}>
          <i />
        </span>
      )}

      {/* Live Blog Icon */}
      {cmstype === 'LIVEBLOG' && (
        <span className={s.liveIconWrapper}>
          <LeadLiveIcon text="Live" />
        </span>
      )}

      {/* Rating Overlay */}
      {criticRating &&
        ![CARD_27, CARD_27_1, CARD_29].includes(cardType) && (
          <div
            className={`${s.ratingWrap} ${cardType === CARD_2 ? s.topPos : ''}`}
          >
            <div className={s.ratingPosition}>
              <div className={s.ratings}>
                <p className={s.ratingsGiven}>
                  {criticRating} <span className={s.starIcon} />
                </p>
                <p className={s.ratingsBy}>Critics</p>
              </div>
            </div>
          </div>
        )}

      {/* Info Icon */}
      {showIIcon && (
        <span
          className={`${s[iconClass]} ${s.infoIcon}`}
          onClick={onShowDesInCard}
        >
          i
        </span>
      )}

      {/* Description Overlay */}
      {des && (
        <p
          className={`${s.infoTextOverlay} ${showDes ? s.show : ''}`}
          dangerouslySetInnerHTML={{ __html: des }}
        />
      )}
    </div>
  );
}

StoryImage.propTypes = {
  msid: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  imagesize: PropTypes.string,
  resizemode: PropTypes.number,
  cardType: PropTypes.string,
  hoveredSlikeId: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  gaIndex: PropTypes.number,
  slikeId: PropTypes.string,
  imageUrl: PropTypes.string,
  shouldNotlazyloadImage: PropTypes.bool,
  imagePlaceHolderSrc: PropTypes.string,
  iconClass: PropTypes.string,
  videoTime: PropTypes.string,
  showPlayIconAlso: PropTypes.bool,
  cmstype: PropTypes.string,
  criticRating: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showIIcon: PropTypes.bool,
  videoviews: PropTypes.string,
  isTrendingorNew: PropTypes.string,
  des: PropTypes.string,
  showDes: PropTypes.bool,
  onVideoIconClick: PropTypes.func,
  onShowDesInCard: PropTypes.func,
  imagelist: PropTypes.arrayOf(
    PropTypes.shape({
      imageid: PropTypes.string,
      imageUrl: PropTypes.string,
    }),
  ),
  occupation: PropTypes.string,
};

StoryImage.defaultProps = {
  width: 600,
  height: undefined,
  imagesize: '',
  resizemode: 4,
  cardType: '',
  hoveredSlikeId: false,
  gaIndex: 0,
  slikeId: '',
  imageUrl: '',
  shouldNotlazyloadImage: false,
  imagePlaceHolderSrc: '',
  iconClass: '',
  videoTime: '',
  showPlayIconAlso: false,
  cmstype: '',
  criticRating: '',
  showIIcon: false,
  videoviews: '',
  isTrendingorNew: '',
  des: '',
  showDes: false,
  onVideoIconClick: () => {},
  onShowDesInCard: () => {},
  imagelist: undefined,
  occupation: '',
};

export default StoryImage;
